module.exports = __webpack_public_path__ + "img/GH-kyujin-top-015.33a51770.webp";